import { useGetUser } from 'v2/core/services/user';

export const useGetTenantSluglessUrl = (): string => {
  const {
    tenant: { slug: tenantSlug },
  } = useGetUser();

  const sluglessPathname = window.location.pathname.replace(
    `/${tenantSlug}`,
    '',
  );

  const searchParams = window.location.search;

  return `${sluglessPathname}${searchParams}`;
};
